import React from 'react';

import { DestructiveModal } from '@capintel/component-lib/destructive-modal';
import { Stack } from '@capintel/component-lib/stack';

import Portfolio from '@/types/portfolio';
import { formatLocalizedString, formatMessage, FormattedMessage } from '@/utils/i18n';

type Props = {
  portfolios: Portfolio[];
  show: boolean;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const DeletePortfoliosModal = ({ isDeleting, portfolios, show, onConfirm, onCancel }: Props) => (
  <DestructiveModal
    open={show}
    onOpenChange={open => !open && onCancel()}
    title={formatMessage('Portfolios.DeleteModal.Title')}
    content={
      <Stack gap="150">
        <FormattedMessage id="Portfolios.DeleteModal.Body" />
        <ul>
          {portfolios.map(p => (
            <li key={p._id} data-private data-dd-privacy="mask">
              {formatLocalizedString(p.name)}
            </li>
          ))}
        </ul>
        <FormattedMessage id="Portfolios.DeleteModal.Confirmation" />
      </Stack>
    }
    confirmButtonText={formatMessage(`Portfolios.DeleteModal.${isDeleting ? 'ConfirmingButton' : 'ConfirmButton'}`)}
    cancelButtonText={formatMessage('Common.Cancel')}
    onConfirm={onConfirm}
    onCancel={onCancel}
    loading={isDeleting}
  />
);

export default DeletePortfoliosModal;
